import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useSelect } from '@wordpress/data';
/**
 * Internal dependencies
 */

import DownloadableBlockAuthorInfo from '../downloadable-block-author-info';
import DownloadableBlockHeader from '../downloadable-block-header';
import DownloadableBlockInfo from '../downloadable-block-info';
import DownloadableBlockNotice from '../downloadable-block-notice';
import { store as blockDirectoryStore } from '../../store';
export default function DownloadableBlockListItem(_ref) {
  var item = _ref.item,
      onClick = _ref.onClick;

  var _useSelect = useSelect(function (select) {
    var _select = select(blockDirectoryStore),
        isInstalling = _select.isInstalling,
        getErrorNoticeForBlock = _select.getErrorNoticeForBlock;

    var notice = getErrorNoticeForBlock(item.id);
    var hasFatal = notice && notice.isFatal;
    return {
      isLoading: isInstalling(item.id),
      isInstallable: !hasFatal
    };
  }, [item]),
      isLoading = _useSelect.isLoading,
      isInstallable = _useSelect.isInstallable;

  var icon = item.icon,
      title = item.title,
      description = item.description,
      rating = item.rating,
      activeInstalls = item.activeInstalls,
      ratingCount = item.ratingCount,
      author = item.author,
      humanizedUpdated = item.humanizedUpdated,
      authorBlockCount = item.authorBlockCount,
      authorBlockRating = item.authorBlockRating;
  return createElement("li", {
    className: "block-directory-downloadable-block-list-item"
  }, createElement("article", {
    className: "block-directory-downloadable-block-list-item__panel"
  }, createElement("header", {
    className: "block-directory-downloadable-block-list-item__header"
  }, createElement(DownloadableBlockHeader, {
    icon: icon,
    onClick: onClick,
    title: title,
    rating: rating,
    ratingCount: ratingCount,
    isLoading: isLoading,
    isInstallable: isInstallable
  })), createElement("section", {
    className: "block-directory-downloadable-block-list-item__body"
  }, createElement(DownloadableBlockNotice, {
    onClick: onClick,
    block: item
  }), createElement(DownloadableBlockInfo, {
    activeInstalls: activeInstalls,
    description: description,
    humanizedUpdated: humanizedUpdated
  })), createElement("footer", {
    className: "block-directory-downloadable-block-list-item__footer"
  }, createElement(DownloadableBlockAuthorInfo, {
    author: author,
    authorBlockCount: authorBlockCount,
    authorBlockRating: authorBlockRating
  }))));
}
//# sourceMappingURL=index.js.map